// 261029 — MỘT hàm sao chép dùng chung cho mọi nút «Sao chép» ở bước Video (màn chính + ngăn chi tiết). Thuần (không antd): nhận clipboard để test; trả true/false, không ném.
export interface ClipboardLike { writeText: (text: string) => Promise<void> }

export async function copyTextToClipboard(text: string, clipboard: ClipboardLike | undefined | null = typeof navigator !== 'undefined' ? navigator.clipboard : undefined): Promise<boolean> {
  if (!clipboard) return false;
  try { await clipboard.writeText(text); return true; } catch { return false; }
}
